// Packages

// Components
import { CustomItems } from "./CustomItems";

// Logic

// Context

// Services

// Styles

// Assets

export const Custom = () => {
	return (
		<div className='unit-page-subpage unit-page-subpage-custom'>
			<CustomItems />
		</div>
	);
};
